export default __webpack_public_path__ + "static/media/scan.4ab9829c.svg";